import { useState } from 'react';
import { isMobile } from '../../../utils/mainLayoutUtils';

/**
 * Hook to manage layout state for MainLayout component
 * @returns {Object} Layout state and setters
 */
export const useMainLayoutState = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(isMobile());
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [searchDialogOpen, setSearchDialogOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  return {
    anchorEl,
    isSidebarCollapsed,
    logoutDialogOpen,
    searchDialogOpen,
    searchQuery,
    setAnchorEl,
    setIsSidebarCollapsed,
    setLogoutDialogOpen,
    setSearchDialogOpen,
    setSearchQuery,
  };
};
